import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';

function EncabezadoRegistro(props){

    
    const [titulo, setTitulo]=useState("Datos de la empresa");
    const [subtitulo, setSubtitulo]=useState("Crea tu  nueva cuenta y cuentanos un poco sobre tu empresa");

    useEffect(() => {
        if(props.idPagina === 1){
            setTitulo("Datos de la empresa");
            setSubtitulo("Creá tu nueva cuenta y contanos un poco sobre tu empresa");
        }
        if(props.idPagina === 2){
            setTitulo("Oferta y demanda");
            setSubtitulo("Contanos un poco más acerca de tus productos");
        }
        else if(props.idPagina === 3){
            setTitulo("Datos de los representantes")
            setSubtitulo('Completá los campos y presioná el botón "Agregar representante"');
        }
        /*else if(props.idPagina === 4){
            setTitulo("Resumen")
        }*/
        for (var i = 2; i <= 3; i++) {
            if(i<=props.idPagina)
                document.getElementById("pagRegis" + i).classList.remove("pagNoActiva");
            else
                document.getElementById("pagRegis" + i).classList.add("pagNoActiva");

        }
      
        
    },[props]) 

    return(  
        <>  
            <div className='row encabezadoRegistro'>
                <div className='col-sm-10  offset-sm-1'>
                    <h2 className='letraTituloRegistro'>{titulo}</h2>   
                    <p className='subtituloRegistro'>{subtitulo}
                       {props.idPagina === 3? <><br/>Podés agregar más de un representante</> : ""}
                    </p>
                    <div className='container mb-3'>
                        <div className='row mx-5 py-3 align-items-center marginPagMobile'>
                            <div className='col  offset-1 me-1' ><div className='pagRegistro'></div></div>
                            <div className='col mx-1'><div id="pagRegis2" className='pagRegistro pagNoActiva'></div></div>
                            <div className='col  mx-1'><div id="pagRegis3" className='pagRegistro pagNoActiva'></div></div>
                            {/*<div className='col ms-1'><div id="pagRegis4" className='pagRegistro pagNoActiva'></div></div>*/}
                            <div className='col-1 '></div>
                        </div>
                    </div>
                </div>
            </div>
               
        </>
    );
}


export default EncabezadoRegistro;